import { TraitActionChoiceOptionData } from './measurement_types';
import { request } from './request';
import { ValueMetaData } from './value_meta_data';

export type ActionType = 'set_value' | 'play_sound' | 'calculate_canopy_standard' | 'calculate_canopy_ai';
export type SoundName = 'success_sound' | 'error_sound';

export const TRAIT_ACTION_TYPES = {
  SET_VALUE: 'set_value' as ActionType,
  PLAY_SOUND: 'play_sound' as ActionType,
  CALCULATE_CANOPY_STANDARD: 'calculate_canopy_standard' as ActionType,
  CALCULATE_CANOPY_AI: 'calculate_canopy_ai' as ActionType,
} as const;

export interface TraitActionData {
  id?: string;
  action_type: ActionType;
  source_measurement_meta_id: string;
  target_measurement_meta_id: string;
  target_measurement_value?: string;
  source_measurement_meta_template_id?: string; // read-only
  target_measurement_meta_template_id?: string; // read-only
  target_measurement_value_template_id?: string; // read-only
  sound_name?: SoundName;
  ai_model?: string;
  prompt?: string;
}

export interface TraitActionSourceData extends Pick<ValueMetaData, 'id' | 'name_json' | 'type'> {
  scheduled_visit_ids: number[];
}
export interface TraitActionTargetData extends Pick<ValueMetaData, 'id' | 'name_json' | 'type'> {
  value_choices: TraitActionChoiceOptionData[];
  scheduled_visit_ids: number[];
}
export interface TraitActionOptionsData {
  sources: TraitActionSourceData[];
  targets: TraitActionTargetData[];
  action_types: { value: ActionType; label: string }[];
  sound_names?: { value: SoundName; label: string }[];
}

export function listTraitActionOptions(params: {
  measurement_meta_ids: string[];
}): Promise<TraitActionOptionsData> {
  return request('POST', `/api/v2/trait_actions/list_options/`, params, {
    injectTenant: true,
    version: 2,
  });
}
